import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {SAVE_TRANSACTION_SUCCESS, SAVE_TRANSACTION_ERROR} from "../../constants";
import {getUserData, reduxSetPayerUser} from "../../Actions/authActions";
import {amountFormatterWithZero} from "../../utils";

const ApplePayNmi = ({
    subdomain,
    adminUser,
    user,
    totalAmount,
    patientPayerInfo,
    showResult,
    setPaymentInfo
}) => {
    const dispatch = useDispatch();
    const [scriptLoaded, setScriptLoaded] = useState(false);

    const getNewPatientPayer = () => {
        const balancesPaid = [];
        patientPayerInfo.forEach((i) => {
            if (i) {
                balancesPaid.push({
                    patientFirst: i.patientFirst,
                    patientLast: i.patientLast,
                    patientNumber: i.patientNumber,
                    patientPayerId: i.patientPayerId,
                    amountPaid: i.accountBalance < 0 ? 0 : i.accountBalance,
                });
            }
        });
        return balancesPaid;
    };

    useEffect(() => {
        if (window.CollectJS && adminUser?.paymentGateways) {
            initializeApplePay();
        }
    }, [window.CollectJS, adminUser, totalAmount]);

    const initializeApplePay = () => {
        try {
            const applePayForm = document.getElementById("applepaymyForm");
            if (applePayForm) {
                applePayForm.style.display = 'block';
            }

            const lineItems = [{label: 'Total', amount: totalAmount.toString()}];

            window.CollectJS.configure({
                variant: 'inline',
                fields: {
                    'applePay': {
                        'selector': '.apple-pay-button',
                        'requiredBillingContactFields': [
                            'postalAddress',
                            'name',
                        ],
                        'contactFields': [
                            'phone',
                            'email'
                        ],
                        'lineItems': lineItems,
                        'contactFieldsMappedTo': 'billing',
                        'totalLabel': 'Total',
                        'type': 'buy',
                        'style': {
                            'button-style': 'white-outline',
                            'height': '50px',
                            'border-radius': '4px'
                        }
                    }
                },
                tokenizationKey: adminUser.paymentGateways.tokenizationKey,
                country: 'US',
                price: totalAmount.toString(),
                currency: 'USD',
                callback: handleApplePayCallback,
            });

            setScriptLoaded(true);
        } catch (error) {
            console.error("Error initializing Apple Pay:", error);
        }
    };

    const handleApplePayCallback = async (response) => {
        try {
            if (response && response.response === '1') {
                // Extract wallet information from the response
                const wallet = response.frontEndGatewayResponse?.wallet || {};
                const billingInfo = wallet.billingInfo || {};
                const card = response.frontEndGatewayResponse?.card || {};

                localStorage.setItem('PENDING_TRANSACTION', JSON.stringify({
                    payerEmail: user.payerEmail,
                    patientPayer: getNewPatientPayer(),
                    total: amountFormatterWithZero(totalAmount),
                    transactionId: response?.transactionid,
                }));

                const updatedPatientPayers = user.patientPayer.map(ptPayer => {
                    const matchingPatientPayer = patientPayerInfo.find(ppInfo =>
                        ppInfo && ppInfo.patientPayerId === ptPayer.patientPayerId
                    );
                    if (matchingPatientPayer) {
                        const unpaidBalance = parseFloat(ptPayer.accountBalance) - parseFloat(matchingPatientPayer.accountBalance);
                        return {
                            ...ptPayer,
                            accountBalance: unpaidBalance,
                        };
                    }
                    return ptPayer;
                });

                const updatedUser = {
                    ...user,
                    patientPayer: updatedPatientPayers,
                };

                localStorage.setItem("state", JSON.stringify({patientPayerInfo: updatedPatientPayers}));
                dispatch(reduxSetPayerUser(updatedUser));
                showResult("approval");
                dispatch({type: SAVE_TRANSACTION_SUCCESS});

                setTimeout(() => {
                    dispatch(getUserData(subdomain));
                    setPaymentInfo({
                        name: "", cardnumber: "", expiry: "", cvv: "",
                    });
                }, 1000);
            } else {
                showResult("error", response);
                dispatch({type: SAVE_TRANSACTION_ERROR});
            }
        } catch (error) {
            console.error("Error processing Apple Pay payment:", error);
            showResult("error", error);
            dispatch({type: SAVE_TRANSACTION_ERROR});
        }
    };

    return (
        <div>
            <iframe
                name="applepaydummyframe"
                id="applepaydummyframe"
                style={{display: "none"}}
            />
            <form
                action="#"
                method="post"
                name="applepaymyForm"
                id="applepaymyForm"
                target="applepaydummyframe"
                style={{display: "none"}}
            >
                <div className="apple-pay-button"/>
            </form>
        </div>
    );
};

export default ApplePayNmi;
